import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import deleteIcon from 'assets/img/deleteIcon_black.png';
import deleteIconWhite from 'assets/img/trashWhite.svg';
import { ErrorModal } from 'components';
import { deleteInvitados } from 'services/rsvp/getRSVP';
import styles from './styles.module.scss';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import { useWindowSize } from 'hooks';
import iconoFilterWeb from 'assets/img/Filter.png';
import iconFilter from 'assets/img/filterIcon.svg';
import iconoAsitira from 'assets/img/IconoAsistira.png';
import iconoPendiente from 'assets/img/IconoPendiente.png';
import iconoNoAsistira from 'assets/img/IconoNoAsistira.png';


const MyGuestsTable = ({ data, onGetActiveItemIds, onGeRefresh }) => {
  const [, { isMobile }] = useWindowSize();
  const [nameSearch, setNameSearch] = useState('');
  const [statusSearch, setStatusSearch] = useState('');
  const [invitacionSearch, setInvitacionSearch] = useState('');
  const [agradecimientoSearch, setAgradecimientoSearch] = useState('');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filteredData, setFilteredData] = useState(data);
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusInvitacion, setstatusInvitacion] = useState([]);
  const [statusAgradecimiento, setStatusAgradecimiento] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [guestId, setGuestId] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [servicioDeleteInvitados, setServicioDeleteInvitados] = useState('');
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  console.log('data en myGuestTable', data);
  useEffect(() => {
    const uniqueStatus = [...new Set(data.map((item) => item.status))];
    setStatusOptions(uniqueStatus);

    const uniqueInvitacion = [...new Set(data.map((item) => item.invitacion))];
    setstatusInvitacion(uniqueInvitacion);

    const uniqueAgradecimiento = [...new Set(data.map((item) => item.agradecimiento))];
    setStatusAgradecimiento(uniqueAgradecimiento);

    setFilteredData(data);

    console.log('data en tabla cambio', data);
    onGetActiveItemIds([]);
    setSelectedItems([]);
  }, [data]);

  const filterAndSortData = (name, status, invitacion, agradecimiento) => {
    let filtered = data.filter((item) =>
      item.name.toLowerCase().includes(name.toLowerCase())
    );

    if (status) {
      filtered = filtered.filter((item) =>
        item.status.toLowerCase() === status.toLowerCase()
      );
    }

    if (invitacion) {
      filtered = filtered.filter((item) =>
        item.invitacion.toLowerCase() === invitacion.toLowerCase()
      );
    }

    if (agradecimiento) {
      filtered = filtered.filter((item) =>
        item.agradecimiento.toLowerCase() === agradecimiento.toLowerCase()
      );
    }

    if (sortColumn === 'name') {
      filtered = filtered.sort((a, b) =>
        sortOrder === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
      );
    } else if (sortColumn === 'status') {
      filtered = filtered.sort((a, b) =>
        sortOrder === 'asc' ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status)
      );
    } else if (sortColumn === 'asistentes') {
      filtered = filtered.sort((a, b) => {
        return sortOrder === 'asc' ? a.asistentes - b.asistentes : b.asistentes - a.asistentes;
      });
    } else if (sortColumn === 'email') {
      filtered = filtered.sort((a, b) =>
        sortOrder === 'asc' ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email)
      );
    } else if (sortColumn === 'invitacion') {
      filtered = filtered.sort((a, b) =>
        sortOrder === 'asc' ? a.invitacion.localeCompare(b.invitacion) : b.invitacion.localeCompare(a.invitacion)
      );
    } else if (sortColumn === 'agradecimiento') {
      filtered = filtered.sort((a, b) =>
        sortOrder === 'asc' ? a.agradecimiento.localeCompare(b.agradecimiento) : b.agradecimiento.localeCompare(a.agradecimiento)
      );
    }

    setFilteredData(filtered);
  };

  const handleNameSearch = (e) => {
    const searchText = e.target.value;
    setNameSearch(searchText);
    filterAndSortData(searchText, statusSearch, invitacionSearch, agradecimientoSearch);
  };

  const handleStatusSearch = (e) => {
    const selectedStatus = e.target.value;
    setStatusSearch(selectedStatus);
    filterAndSortData(nameSearch, selectedStatus, invitacionSearch, agradecimientoSearch);
  };

  const handleInvitacionSearch = (e) => {
    const selectedInvitacion = e.target.value;
    setInvitacionSearch(selectedInvitacion);
    filterAndSortData(nameSearch, statusSearch, selectedInvitacion, agradecimientoSearch);
  };

  const handleAgradecimientoSearch = (e) => {
    const selectedAgradecimiento = e.target.value;
    setAgradecimientoSearch(selectedAgradecimiento);
    filterAndSortData(nameSearch, statusSearch, invitacionSearch, selectedAgradecimiento);
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
    filterAndSortData(nameSearch, statusSearch, invitacionSearch, agradecimientoSearch);
  };

  const handleClose = () => {
    setShowErrorModal(false);
  };
  const handleClickDelete = (guestId) => {
    console.log('Clic ', guestId);
    setShowErrorModal(true);
    setGuestId(guestId);
  };

  const handleClickDeleteConfirm = () => {
    console.log('LLamar servicio eliminar guestID ', guestId);
    dispatch(showLoader());
    deleteInvitados(guestId).then((valorDeServicio) => {
      setServicioDeleteInvitados(valorDeServicio);
      console.log('deleteInvitados ', valorDeServicio);
      console.log('servicioDeleteInvitados ', valorDeServicio?.data?.success);
      if (valorDeServicio?.data?.success == true) {
        console.log('LLamar servicio para volver a cargar la data Pendiente');
        //alert('Invitado eliminado correctamente');
        onGeRefresh();
        dispatch(hideLoader());
      } else {
        //alert('Error al eliminar invitado');
        console.log('Error al eliminar invitado');
        onGeRefresh();
        dispatch(hideLoader());
      }
    });
    setShowErrorModal(false);

  };

  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
      onGetActiveItemIds(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
      onGetActiveItemIds([...selectedItems, itemId]);
    }
  };

  const handleMasterCheckboxChange = () => {
    if (selectAll) {
      // Deseleccionar todos los elementos si el checkbox maestro está seleccionado
      setSelectedItems([]);
      onGetActiveItemIds([]);
    } else {
      // Seleccionar todos los elementos si el checkbox maestro no está seleccionado
      const allItemIds = filteredData.map((item) => item.gift_table_guest_id);
      setSelectedItems(allItemIds);
      onGetActiveItemIds(allItemIds);
    }
    // Cambiar el estado del checkbox maestro
    setSelectAll(!selectAll);
  };

  return (
    <div>
      <div className='row'>
        <div className="col-md-6" style={{ display: 'inline-flex' }}>
          <div className="input-group">
            
            <input
              type="search"
              placeholder="Busqueda por : Nombre Invitado"
              value={nameSearch}
              onChange={handleNameSearch}
              className={`${styles.inputsearch} form-control form-control-sm border rounded-pill pl-5`} // Agregamos padding a la izquierda para el ícono
            />
            <div className={`${styles.msn5} input-group-prepend`}>
              <span className="input-group-text bg-transparent border-0">
                <i className='fa fa-search'></i>
              </span>
            </div>
            
          </div>
          {isMobile && (
            <img style={{height:'35px', paddingTop:'5px' }} src={iconFilter}   />
          )}
        </div>
        {!isMobile &&(
        <div className="row">
          <div className="col-md-4">
            <select value={statusSearch} onChange={handleStatusSearch} className={`${styles.selectstatus} form-control`}>
              <option value="">Estatus</option>
              {statusOptions.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <select value={invitacionSearch} onChange={handleInvitacionSearch} className={`${styles.selectinv} form-control`}>
              <option value="">Invitación</option>
              {statusInvitacion.map((invitacion, index) => (
                <option key={index} value={invitacion}>
                  {invitacion}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <select value={agradecimientoSearch} onChange={handleAgradecimientoSearch} className={`${styles.selectagr} form-control`}>
              <option value="">Agradecimiento</option>
              {statusAgradecimiento.map((agradecimiento, index) => (
                <option key={index} value={agradecimiento}>
                  {agradecimiento}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      </div>
      <br />
      <div className="row">
        <div className={`${styles.tableresp} table-responsive border `} style={{ overflowY: 'auto', maxHeight: '500px' }}>
          {!isMobile ? (
            <Table striped>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleMasterCheckboxChange}
                    />
                  </th>
                  <th onClick={() => handleSort('name')}>
                    Nombre {sortColumn === 'name' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th onClick={() => handleSort('asistentes')}>
                    Asistentes {sortColumn === 'asistentes' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th onClick={() => handleSort('status')}>
                    Estatus {sortColumn === 'status' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th onClick={() => handleSort('email')}>
                    Email {sortColumn === 'email' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th onClick={() => handleSort('invitacion')}>
                    Invitacion {sortColumn === 'invitacion' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th onClick={() => handleSort('agradecimiento')}>
                    Agradecimiento {sortColumn === 'agradecimiento' && sortOrder === 'asc' ? <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> : <img style={{ height: '30px', paddingTop: '5px', alignItems: 'baseline' }} src={iconoFilterWeb} /> }
                  </th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item) => (
                  <tr key={item.gift_table_guest_id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item.gift_table_guest_id)}
                        onChange={() => handleCheckboxChange(item.gift_table_guest_id)}
                      />
                    </td>
                    <td style={{ textAlign: 'left' }}>{item.name}</td>
                    <td>{item.asistentes}</td>
                    <td style={{ textAlign: 'left', color: item.status === 'asistira' ? 'green' : item.status === 'pendiente' ? 'orange' : item.status === 'no asistira' ? 'red' : 'grey' }}>{item.status}
                    &nbsp; &nbsp;
                    {item.status === 'asistira' && ( <img style={{ height: '30px', paddingTop: '5px', alignItems: 'top' }} src={iconoAsitira} />)}
                    {item.status === 'pendiente' && ( <img style={{ height: '30px', paddingTop: '5px', alignItems: 'top' }} src={iconoPendiente} />)}
                    {item.status === 'no asistira' && ( <img style={{ height: '30px', paddingTop: '5px', alignItems: 'top' }} src={iconoNoAsistira} />)}
                    </td>
                    <td style={{ textAlign: 'left' }}>{item.email}</td>
                    <td style={{ textAlign: 'left', color: item.invitacion === 'enviado' ? 'green' : item.invitacion === 'reenviado' ? 'green' : 'grey' }}>{item.invitacion}</td>
                    <td style={{ textAlign: 'left', color:'grey'}}>{item.agradecimiento}</td>
                    <td><img src={deleteIcon} alt="Eliminar invitado" onClick={() => handleClickDelete(item.gift_table_guest_id)} /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ):
          (
            <Table >
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleMasterCheckboxChange}
                    />
                  </th>

                  <th>Seleccionar todos&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item) => (
                  <tr key={item.gift_table_guest_id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item.gift_table_guest_id)}
                        onChange={() => handleCheckboxChange(item.gift_table_guest_id)}
                      />
                    </td>
                    <td>
                      <div className="d-flex">
                        <div className={styles.leftContent} >
                          <b className="card-title"><strong>{item.name}</strong></b>
                          <p className={styles.spanText}>

                            { item.status != 'no asistira' &&  (item.asistentes > 1 ? item.asistentes + ' acompañantes' : item.asistentes + ' acompañante')}
                          </p>
                          <p style={{  fontSize: '0.8rem' }} className={` ${
                            item.status === 'sin estatus' ? styles.sinEstatus :
                            item.status === 'pendiente' ? styles.pendiente  :
                            item.status === 'asistira' ? styles.asistira  : 
                            item.status === 'no asistira' && styles.sinEstatus }`}>
                            {item.status === 'sin estatus' ? (<>Sin estatus <i className="fa fa-close" /> </>)  :
                              item.status === 'pendiente' ?  (<>Pendiente <i className="fa fa-clock-o " /> </>)  :
                              item.status === 'asistira' ? (<>Asistirá <i className="fa fa-check-circle-o" /> </>)  : 
                              item.status === 'no asistira' &&  (<>No Asistirá <i className="fa fa-close" /> </>) 
                              }
                          </p>
                          <p className={styles.spanText}>{item.email}</p>
                        </div>
                        <div className={styles.rightContent} >
                          <img style={{height:'35px'}} src={deleteIconWhite} alt="Eliminar invitado" onClick={() => handleClickDelete(item.gift_table_guest_id)} />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )
          
          } 

        </div>
      </div>
      <ErrorModal
        show={showErrorModal}
        title=""
        titleHeader=""
        titleHeaderClassName="col-md-12 offset-md-3"
        actionLabel="Eliminar"
        onAction={handleClickDeleteConfirm}
        onClose={handleClose}
        closeLabel='Eliminar'
        type={''}
        subtitle={
          <p className="text-center">
            <b>Eliminar invitado</b><br /><br />
            ¿Estás seguro que deseas<br />
            eliminar a tu invitado y la<br />
            información de sus<br />
            acompañantes?<br />
          </p>
        }
      />
    </div >
  );
};

export default MyGuestsTable;
